import {useEffect, useState} from 'react';

import {useDispatch} from 'react-redux';
import {useSearchParams} from 'react-router-dom';

import {FontFamilyList, loadFontFaces, normalizeFontList} from './fontUtils';

import {fetchOrganizationSettingForExternal} from 'Store/OrganizationSettingStore';
import {setFontFaceSrc, updateFontFamily} from 'Store/ThemeStore';

const sanitizeFontFamily = (value) => value?.replace(/[^a-zA-Z0-9\s,'"_-]/g, '');

const useFontStyle = (user) => {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const embedWidgetParams = searchParams.get('embedStyle') || '';

  let embedWidgetStyle = {};
  try {
    embedWidgetStyle = JSON.parse(embedWidgetParams);
  } catch (error) {}

  const embedFontFamily = sanitizeFontFamily(embedWidgetStyle.fontFamily);
  const [fontFamily, setFontFamily] = useState('');

  const isCustomFont = !!fontFamily &&
    !FontFamilyList.map((font) => font.toLowerCase()).includes(fontFamily.toLowerCase());

  useEffect(() => {
    if (!embedFontFamily || !user) {
      return;
    }
    if (!isCustomFont) {
      setFontFamily(embedFontFamily);
      return;
    }
    (async () => {
      try {
        const settings = await dispatch(fetchOrganizationSettingForExternal(user)).unwrap();
        const fontList = normalizeFontList(settings.fontList);
        const familyFonts = fontList.filter((font) => font.family === embedFontFamily);
        if (familyFonts.length) {
          setFontFamily(embedFontFamily);
          const loadSuccess = await Promise.allSettled(loadFontFaces(familyFonts));
          if (loadSuccess.some((res) => res.status === 'fulfilled')) {
            // Accept partial load failures if any one of the font family variants succeeds.
            dispatch(setFontFaceSrc({fontName: embedFontFamily, fontSrc: embedFontFamily}));
          }
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [isCustomFont, user, embedFontFamily, dispatch]);

  useEffect(() => {
    if (fontFamily) {
      dispatch(updateFontFamily(fontFamily));
    }
  }, [fontFamily, dispatch]);

  return {fontFamily};
};

export default useFontStyle;
